import styled from 'styled-components'
import { Menu } from 'antd'

export const StyledMenu = styled(Menu)`
  height: 100%;

  .ant-menu-item-selected {
    background-color: ${props => props.theme.primaryColor} !important;
    color: white !important;
    path {
      fill: white !important;
    }
  }
`
export const StyledMenuItem = styled(Menu.Item)`
  & span {
    margin-left: 10px;
  }
`
